/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { reviewHistoryItemSchema } from '../getReviewHistory/review-history-item-schema';

export const reviewHistoryItemV3Schema = reviewHistoryItemSchema.extend({
  queueSource: z.enum(['onboarding', 'random']).nullable(),
  hasVideo: z.boolean(),
});

export type IReviewHistoryItemV3 = z.infer<typeof reviewHistoryItemV3Schema>;

export const getReviewHistoryV3ResponseDataSchema = z.array(reviewHistoryItemV3Schema);

export type IGetReviewHistoryV3ResponseData = z.infer<typeof getReviewHistoryV3ResponseDataSchema>;

export const getReviewHistoryV3ResponseSchema = createApiResponseSchema(
  getReviewHistoryV3ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetReviewHistoryV3ResponseData>>;

export type IGetReviewHistoryV3Response = IAPI<IGetReviewHistoryV3ResponseData>;
